module.exports = {"title":"답변 등록","replyStatus":"답변 여부","answered":"답변완료","checking":"확인중","contentPlaceholder":"내용을 입력하세요.","confirmMessage":"답변을 등록하면 문의자에게<br>알림이 발송됩니다.<br>이대로 등록하시겠습니까?","registeredAlert":"답변이 등록되었습니다.","typeService":"서비스","typeEvent":"이벤트","typeUpdate":"업데이트"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/cs105.json
// module id = q9+Y
// module chunks = 2